@if (state.showAnimatedBackground()) {
    <video class="video-bg" autoplay muted loop>
        <source src="../../assets/video/cityscape_1080.mp4" type="video/mp4" />
    </video>
} @else {
    <!--    <div class="image-bg">-->
    <!--        &lt;!&ndash;        <img alt="cityscape" ngSrc="../../assets/images/cityscape.jpg" fill />&ndash;&gt;-->
    <!--    </div>-->
}

<div class="dashboard">
    @if (apps()?.length) {
        <mat-grid-list [cols]="sphereAppGalleryColumns()" rowHeight="100px" gutterSize="10px">
            @for (app of apps(); track $index) {
                <mat-grid-tile class="AppCardWrapper">
                    <sphere-home-app-card
                        mode="app"
                        [app]="app"
                        [disableFavoriteToggle]="true"
                        (mouseenter)="setHoverApp(app)"
                        (mouseleave)="setHoverApp(null)"
                    />
                </mat-grid-tile>
            }
        </mat-grid-list>
    } @else {
        <p class="no-apps-message">We're sorry, you are not authorized to use any application. Please contact your system administrator.</p>
    }
</div>
<div
    class="SphereDashboard_BackgroundGradient"
    [@cardHover]="{ value: hoverAppColorRaw(), params: { start: hoverAppColorRange().start, end: hoverAppColorRange().end } }"
></div>
<img src="/assets/images/bg-graph.svg" alt="Decorative" class="SphereDashboard_AccentGraph" />

<!--<section class="dashboard-bottom-section">-->
<!--    <mat-divider [style.margin-bottom.px]="20" />-->
<!--    <mat-slide-toggle [checked]="state.showAnimatedBackground()" (toggleChange)="setShowAnimatedBackground()">Animated background</mat-slide-toggle>-->
<!--</section>-->
